module.exports = __webpack_public_path__ + "assets/img/yang.d1eaa784.png";